import { useContext, useEffect, useState } from 'react';
import app_setting_logo from "../../../sat-landing/img/solar_qr-code-line-duotone.svg";
import PortalLink from './PortalLink';
import RecentNotices from './RecentNotices';
import { UserDataContext } from '../../../userProfile';
import { ProfileContext } from '../../../components/UserProfile/UserProfile';
import { NavLink } from 'react-router-dom';
import BusinessCardPopup from '../../../components/QRForm/BusinessCardPopup';

const HomeComponent = (props: any) => {
  const data = useContext(UserDataContext);
  const [showQR,setShowQR]=useState<boolean>(false);
  const profileContext: any = useContext(ProfileContext);
  const [profileData, setProfile] = useState<any>(
    profileContext?.profileData?.employee
  );
  const change_date_format = (date: Date) => {
    const formatted = date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    return formatted;
  }
  useEffect(() => {
      setProfile(profileContext?.profileData?.employee);
    }, [profileContext]);
  return (
    <div>
      <div className="flex justify-between items-center px-5">
        <div className='w-full pr-5'>
          <p className="text-body-sm text-darkblackv2 font-normal leading-[150%] text-left">{change_date_format(new Date())}</p>
          <div>
            <p className="font-bold heading1 text-sat_darkblackv2 leading-[normal] break-words text-left">
              {profileData?.name}
            </p>
            <p className="font-normal heading3 text-[#28282850] text-left">
              {profileData?.employeeID}
            </p>
            <p className="font-normal text-darkblackv2 heading3 mt-2 text-left mb-[10px]">
              {profileData?.jobTitle}
            </p>
          </div>
        </div>
        <button onClick={()=>setShowQR(true)}>
          <img src={app_setting_logo} alt="app_setting_logo" className='min-w-10'/>
        </button>
      </div>
      <PortalLink />
      <RecentNotices />
      <BusinessCardPopup show={showQR} setShow={setShowQR}
      position={profileData?.jobTitle}
      name={profileData?.name}
      employeeID={profileData?.employeeID}
      qr_image={profileData?.qr_in_code}
      />
    </div>
  );
};

export default HomeComponent;
